import anime from "animejs";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Cookies from "js-cookie";

gsap.registerPlugin(ScrollToPlugin);

export default {
    name: 'home',
    component() {
        return {
            intro: true,
            body: "",
            scrollTopLock: 0,
            sidebar: 1,
            selected: 1, 
            visible: false,
            removeIntro: false,

            init() {

                let cookie = Cookies.get("showIntro");

                this.body = document.querySelector("body");
                let header = document.querySelector("header");

                document.querySelector('.page__line').style.transform = "scale(1, 0)";


                window.addEventListener('scroll', function() {
                    let currY = document.documentElement.scrollTop;
                    let postHeight = window.innerHeight;
                    let scrollHeight = document.querySelector("[data-page]").getBoundingClientRect().height + 1000;
                    let scrollPercent = (currY / (scrollHeight - postHeight)) * 100;
                    let sidebar = document.querySelector("[data-sidebar]").querySelector("div");

                    document.querySelector('.page__line').style.transform = `scale(1, ${scrollPercent}%)`;
                    sidebar.style.top = `${scrollPercent}%`;
                });
                
                header.classList.add("opacity-0");
                header.classList.add("pointer-events-none");
                
                this.enableBodyScrollLock();
                
                let video = document.querySelector("[data-intro-video]");

                if(cookie == undefined) {
                    video.pause();
    
                    setTimeout(() => {
                        video.play();
                    }, 700);
    
                    video.addEventListener("ended", () => {
                        setTimeout(() => {
                            this.intro = false;
                            header.classList.remove("opacity-0");
                            header.classList.remove("pointer-events-none");
                            this.disableBodyScrollLock();
                            Cookies.set("showIntro", true, { expires: 1 });
                        }, 0);
                    });
                    
                } else {
                        this.removeIntro = true;
                    // setTimeout(() => {
                        this.intro = false;
                        header.classList.remove("opacity-0");
                        header.classList.remove("pointer-events-none");
                        this.disableBodyScrollLock();
                        Cookies.set("showIntro", true, { expires: 1 });
                    // }, 0);
                }

                let videos = document.querySelectorAll("[data-scent-vid]");
                videos.forEach((vid) => {
                    vid.currentTime = 0;
                    vid.pause();
                });

                let scentItems = document.querySelector("[data-scent-items]");
            },

            enableBodyScrollLock() {
                this.scrollTopLock =
                    document.documentElement.scrollTop || document.body.scrollTop;
                this.body.style.overflow = "hidden";
                this.body.style.position = "fixed";
                this.body.style.top = `-${this.scrollTopLock}px`;
                this.body.style.width = "100%";
            },
        
            disableBodyScrollLock() {
                this.body.style.removeProperty("overflow");
                this.body.style.removeProperty("position");
                this.body.style.removeProperty("top");
                this.body.style.removeProperty("width");
                window.scrollTo(0, this.scrollTopLock);
            },
            
            enterChange(number) {
                let img = document.querySelector(`[data-scent-img='${number}']`);
                img.style.left = `${Math.floor(Math.random() * 60) - 10}%`;

                if(window.innerWidth > 999) {
                    img.style.top = `${(Math.floor(Math.random() * 60)) - 10}%`;
                } else {
                    img.style.top = `${(Math.floor(Math.random() * 90)) - 10}%`;
                }
                this.selected = number; 


                let vid = document.querySelector(`[data-scent-vid='${number}']`);
                vid.currentTime = 0;
                vid.play();

                // this.unScribble(`${number}`);
            },

            resetScriblle(number) {
                let vid = document.querySelector(`[data-scent-vid='${number}']`);
                vid.currentTime = 0;
                vid.pause();
            }
        }
    }
}